// extracted by mini-css-extract-plugin
var _1 = "ScrollFadeDefault__bottom--MP8Hg";
var _2 = "ScrollFadeDefault__left--Vo13i";
var _3 = "ScrollFadeDefault__right--OnSTP";
var _4 = "ScrollFadeDefault__top--YIgwK";
export { _1 as "bottom", _2 as "left", _3 as "right", _4 as "top" }
